<template>
    <div>
        <div class="map" @click.stop>
            <div class="map-box" >
                <div v-if="hoverKey" :class="['key' + hoverKey, 'map-tag']">
                    <span class="font-style-s">{{ hoverName }}</span>
                    <i></i>
                </div>
            </div>
            <div class="map-text font-style-s">
                <h4>顺昌大圣祭坛分布导览</h4>
                <el-carousel height="20.55vw" :autoplay="false" arrow="never">
                    <el-carousel-item >
                        <ul>
                            <li
                                v-for="(item, i) in lists.slice(0, 12)"
                                :key="i"
                                @click="handleItem(item)"
                                @mouseenter="mouseenter(item)"
                                @mouseleave="hoverKey = null"
                                :class="{ active: itemDetail.name === item.name, ['key' + item.key]: true }"
                            >
                                <div>
                                    <p>{{ item.name }}</p>
                                    <p class="desc" v-if="item.desc">{{ item.desc }}</p>
                                </div>
                            </li>
                        </ul>
                    </el-carousel-item>
                    <el-carousel-item >
                        <ul>
                            <li
                                v-for="(item, i) in lists.slice(12)"
                                :key="i"
                                @click="handleItem(item)"
                                :class="{ active: itemDetail.name === item.name, ['key' + item.key]: true }"
                                @mouseenter="mouseenter(item)"
                                @mouseleave="hoverKey = null"
                            >
                                <div>
                                    <p>{{ item.name }}</p>
                                    <p class="desc" v-if="item.desc">{{ item.desc }}</p>
                                </div>
                            </li>
                        </ul>
                    </el-carousel-item>
                </el-carousel>

            </div>
        </div>
        <!--   微信小程序的弹窗     -->
        <Dialog
            :dialog-visible.sync="dialog"
            :showFooter="false"
            :showCancelBtn="false"
            :show-submit-btn="false"
            @close="stopVoice"
        >
            <div class="ex-tip-wrapper">
                <div class="ex-tips-tit">
                    <div class="ex-tips-tit-con">
                        <img class="ex-img-desc" :src="itemDetail.img" alt="" />
                        <div class="ex-h5 font-style-s">
                            <img class="ex-img" src="@/assets/imgs/whdh/1@2x.png" alt="" />
                            {{ itemDetail.name }}
                            <img class="ex-img" src="@/assets/imgs/whdh/2@2x.png" alt="" />
                        </div>
                        <p class="ex-desc">{{ itemDetail.desc }}</p>
                    </div>
                    <img
                        v-if="!isPlaying"
                        class="ex-voice-icon"
                        @click="playVoice"
                        src="@/assets/imgs/ds/start.jpg"
                        alt=""
                    />
                    <img v-else
                         class="ex-voice-icon"
                         @click="stopVoice"
                         src="@/assets/imgs/ds/stop.jpg"
                         alt="" />
                </div>
                <div class="ex-tip-content">
                    {{ itemDetail.text }}
                    <img class="ex-tip-btn"
                         @click="handleTipClick"
                         src="@/assets/imgs/whdh/11@2x.png"
                         alt="" />
                </div>
                <div class="ex-close" @click="dialog = false">
                    <i class="el-icon-circle-close"></i>
                    <p>关闭</p>
                </div>
            </div>

        </Dialog>
    </div>
</template>
<script setup>
import { ref, onUnmounted } from 'vue';
import Dialog from '@/components/dialog.vue';
const lists = ref([
    {
        key: '1',
        name: '宝山上庵通天堂',
        desc: '（双圣享堂）',
        img: '/image/pic/pic11.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%AE%9D%E5%B1%B1%E4%B8%8A%E5%BA%B5%E9%80%9A%E5%A4%A9%E5%A0%82.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E5%AE%9D%E5%B1%B1/@13100782.03,3090368.66,19z?uid=bba873884a03aaa0bca822e6&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '俗称"大圣祖庙"。位于宝山上庵南天门，与南天门建筑背对背依山势而筑。坐东南向西北，建筑面积约18平方米。堂内以墓式供"齐天大圣"和"通天大圣"神位。墓冢呈八字形，宽2.9米、深1.3米。墓首(墓顶石)呈屋脊状，中央雕刻葫芦"脊刹",两端"脊吻"呈鱼尾状上翘，长0.76米、高0.25米。墓台上并立两碑，间距0.18米。左碑宽0.3米、高0.8米、厚0.12米，荷叶帽碑顶，碑額浮雕授带、拂尘、法螺图案。碑文上方横刻"宝峰"二字，中间竖行阴刻"齐天大圣",下端横刻"神位",外框浮雕如意卷草纹装饰。右碑宽0.33米、高0.8米、厚0.11米，荷叶帽碑顶，碑额浮雕桃枝花卉纹，碑文竖行阴刻"通天大圣",下端横刻"神位",外框浮雕如意卷草纹装饰。据宝山寺大殿及南天门建筑纪年显示，该建筑修造年代至少不晚于明洪武二十四年(1391年)。'
    },
    {
        key: '2',
        name: '曲村通天大圣祭坛',
        desc: '（元坑镇曲村村）',
        img: '/image/pic/pic13.png',
        voice: 'https://file.scxbwg.cn/audio/%E6%9B%B2%E6%9D%91%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E6%9B%B2%E6%9D%91/@13099068.870000001,3108165.285,11z?uid=101bc61b50a287a0c42ba13b&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '位于元坑镇曲村村，元至正年间建。坐东向西，坛基已毁，地面散见坛基须弥座及石制构件。坛树一碑，碑面竖行阴刻"通天大圣",通高1.81米、高1.36米、宽0.52米、厚0.14米，碑顶雕饰荷叶帽，帽高0.26米，碑文下端雕饰七瓣莲花纹，碑左表皮竖行阴刻："三山长邑大匠张天赐造，本坊主缘张骏忠建"两行铭文。碑座呈梯形，上底宽0.63米、下底宽0.80米、高0.45米、厚约0.30米，阴刻框边装饰。据清宣统《曲村张氏族谱》记载："张骏忠，官拜朝散大夫...生元延祐甲子(1324)卒至正丙午(1366)享年四十三"推断，该祭坛建于元代至正年间。'
    },
    {
        key: '3',
        name: '岐头通天大圣坛庙',
        desc: '（岚下乡黄墩村）',
        img: '/image/pic/pic8.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%B2%90%E5%A4%B4%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E5%9D%9B%E5%BA%99.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E9%BB%84%E5%A2%A9%E6%9D%91/@13142128,3102721.2,19z?uid=d6ee87244f725be0a8f0cdfc&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '位于岚下乡黄墩村，为前亭后坛式，木构前庙为明代建筑，后坛为元代建筑，坐东向西。亭，单开间带周栏，重檐歇山顶，抬梁穿斗式构架，斗拱造型优雅古朴。亭后部中央置神龛，祀通天大圣"白衣秀才"造型神像。亭后约1米为通天大圣祭坛。朝向与庙一致，依山而筑。由拜台、祭台和三通坛碑组成。左碑碑额断损，碑面残存竖行阴刻线条勾勒"山黄石公",疑前缺"开"字。通高0.75米、残碑高0.58米、宽0.26米、厚0.07米，阴刻框边装饰，距中碑约0.35米。中碑竖行框边阴刻"通天大圣",通高1.26米、碑高0.98米、宽0.30米、厚0.08米，碑顶雕饰荷叶帽，阴刻框边装饰。右碑碑底断损，碑面残存竖行框边阴刻"本坛土地",疑缺"神"字。通高0.66米、残碑高0.49米、宽0.26米、厚0.07米，阴刻框边装饰，与中碑间距约0.35米。'
    },
    {
        key: '4',
        name: '双舟尾通天大圣祭坛',
        desc: '（埔上镇张墩村）',
        img: '/image/pic/pic17.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%8F%8C%E8%88%9F%E5%B0%BE%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%BC%A0%E5%A2%A9%E6%9D%91/@13110608.5,3092558.07,19z?querytype=s&da_src=shareurl&wd=%E5%BC%A0%E5%A2%A9%E6%9D%91&c=133&src=0&wd2=%E5%8D%97%E5%B9%B3%E5%B8%82%E9%A1%BA%E6%98%8C%E5%8E%BF&pn=0&sug=1&l=19&b=(13104542.52,3067192.28;13105021.52,3067651.28)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=606ab0d09b113f2a0e3ddafd&device_ratio=1',
        text: '位于埔上镇张墩村，明代建筑。坐西北向东南，占地面积约16平方米，由当代新筑拜台、祭台、香池和旧坛碑组成，坛碑花岗岩材质，圆弧顶，框边阴刻装饰，高0.93米、宽0.43米、厚0.13米，正面竖行阴刻："通天大圣",背面竖行繁体阴刻："洪武戊寅(1398)十二月口杨银娘舍三尊"。'
    },
    {
        key: '5',
        name: '村头坪通天大圣祭坛群',
        desc: '（岚下乡郭城村）',
        img: '/image/pic/pic1.png',
        voice: 'https://file.scxbwg.cn/audio/%E6%9D%91%E5%A4%B4%E5%9D%AA%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B%E7%BE%A4.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E6%9D%91%E5%A4%B4%E5%9D%AA/@13137960.885,3116434.285,11z?uid=53349ee3c75bcf6e220262fd&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '位于岚下乡郭城村，洪武甲子年(1384年)建。坐西南向东北，占地面积约36平方米。祭坛上参差立有六通坛碑：1#碑竖行阴刻线条勾勒边框楷书"本坛土地",碑顶断损，无座，残高1.01米，宽0.34米，厚约0.10米。2#碑竖行阴刻线条勾勒边框楷书"本坛土地正神",通高1.26米，碑高0.90米，宽0.37米，厚约0.10米。3#碑竖行阴刻线条勾勒边框楷书"通天大圣",通高1.58米，碑高1.20米，宽0.38米，厚不规则。4#碑竖行阴刻线条勾勒边框楷书"玉封通天大圣",通高1.36厘米，碑高1米，宽0.37米，厚约0.10米。5#碑竖行阴刻线条勾勒边框楷书"通天大圣",通高1.20米，碑高0.94米，宽0.46米，厚约0.20米，碑座正面自右向左竖行阴刻"信士口口，室谢口娘，洪武甲子，喜舍成造"四行铭文。6#碑竖行阴刻线条勾勒边框楷书"开山黄石尊公",通高1.28米，碑高0.93米，宽0.36米，厚约0.14米，碑顶呈弧形。从形制和碑料所用石质不同分析，该祭坛六块坛碑应是由三组集中组成，其中，1#、3#为一组(缺黄公道者碑);2#、4#、6#为一组；5#为一组(缺本坛土地和黄公道者碑)。六碑和香台构成神坛，坛后是数株风水树茂盛，坛前为1989年原址重建的通天庙。'
    },
    {
        key: '6',
        name: '下科通天大圣祭坛',
        desc: '（高阳乡紫竹村）',
        img: '/image/pic/pic2.png',
        voice: 'https://file.scxbwg.cn/audio/%E4%B8%8B%E7%A7%91%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E9%AB%98%E9%98%B3%E4%B9%A1%E7%B4%AB%E7%AB%B9%E6%9D%91/@13145276.875,3093246.97,19z?querytype=s&da_src=shareurl&wd=%E9%AB%98%E9%98%B3%E4%B9%A1%E7%B4%AB%E7%AB%B9%E6%9D%91&c=133&src=0&pn=0&sug=0&l=13&b=(13113600.885,3105546.285;13168320.885,3133322.285)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2',
        text: '位于高阳乡紫竹村，明代建筑，坐西北向东南，由拜台、祭台和三块坛碑组成，占地面积约50平方米。片石垒砌拜台和祭台，从左至右依次为"黄公道者"、"通天大圣"、"本坛土地"带座坛碑。'
    },
    {
        key: '7',
        name: '峡头通天大圣祭坛',
        desc: '（郑坊镇榜山村）',
        img: '/image/pic/pic3.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%B3%A1%E5%A4%B4%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E9%83%91%E5%9D%8A%E9%95%87%E6%A6%9C%E5%B1%B1%E6%9D%91/@13111748.325,3065385.06,12.07z?querytype=s&da_src=shareurl&wd=%E9%83%91%E5%9D%8A%E9%95%87%E6%A6%9C%E5%B1%B1%E6%9D%91&c=133&src=0&pn=0&sug=0&l=19&b=(13144849.375,3093029.97;13145704.375,3093463.97)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2',
        text: '位于郑坊镇榜山村，明代建筑，依山而筑，坐北向南。依次由拜台、祭台及三块坛碑组成，占地面积约30平方米。左碑阴刻"黄公道者",通高1.3米、高0.98米、宽0.3米、厚0.38米；中碑阴刻"通天大圣仁济真君",通高1.45米、高1.11米、宽0.51米、厚0.11米，题款："大明万历乙巳岁季夏月口立",落款："坛越主口世口";右碑阴刻"本坛土地",通高1.23米、高0.90米、宽0.38米、厚0.12米。'
    },
    {
        key: '8',
        name: '西坑通天大圣祭坛',
        desc: '（岚下乡东坑村）',
        img: '/image/pic/pic4.png',
        voice: 'https://file.scxbwg.cn/audio/%E8%A5%BF%E5%9D%91%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%B2%9A%E4%B8%8B%E4%B9%A1%E4%B8%9C%E5%9D%91%E6%9D%91/@13142245.725,3098520.92,19z?querytype=s&da_src=shareurl&wd=%E5%B2%9A%E4%B8%8B%E4%B9%A1%E4%B8%9C%E5%9D%91%E6%9D%91&c=133&src=0&pn=0&sug=0&l=12&b=(13068527.90359852,3040088.3610401414;13172826.16689878,3093030.403463899)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2',
        text: '位于岚下乡东坑村，明代建筑，坐东向西，祭坛平面呈风字形，由拜台、祭台、坛碑组成，占地面积约60平方米。祭台中心置一石质香炉，祭台上一字并立三块砖质连座坛碑，左中右分别为"开山黄石公"、"通天大圣"、"本坛土地",通高分别为0.76米、0.89米、0.73米，宽厚均为宽0.31米、厚0.10米。'
    },
    {
        key: '9',
        name: '天台山通天大圣祭坛',
        desc: '（洋口镇田坪村）',
        img: '/image/pic/pic5.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%A4%A9%E5%8F%B0%E5%B1%B1%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E5%A4%A9%E5%8F%B0%E5%B1%B1/@13118765.28,3064594.45,19z?uid=6deee3088261a16928fc48b4&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '位于洋口镇田坪村，明代建筑。坐西北向东南，占地面积约29平方米。由路亭和四块坛碑组成，亭为当代重建。坛碑砂岩材质。左右两碑无字。前碑通高0.86米、碑高0.43米、宽0.33米、厚0.10米，碑文阴刻"檀那居士";后碑无座，高1.09米、宽0.38米、厚0.10米，碑文阴刻"通天大圣仁济真君",题款"万历十二年(1585年)……"。'
    },
    {
        key: '10',
        name: '石公坛通天大圣祭坛',
        desc: '（元坑镇赖源村）',
        img: '/image/pic/pic6.png',
        voice: 'https://file.scxbwg.cn/audio/%E7%9F%B3%E5%85%AC%E5%9D%9B%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%85%83%E5%9D%91%E9%95%87%E8%B5%96%E6%BA%90%E6%9D%91/@13095481.525,3066523.52,19z?querytype=s&da_src=shareurl&wd=%E5%85%83%E5%9D%91%E9%95%87%E8%B5%96%E6%BA%90%E6%9D%91&c=133&src=0&pn=0&sug=0&l=19&b=(13141818.225,3098303.92;13142673.225,3098737.92)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2',
        text: '位于元坑镇赖源村，明代建筑。坐西南向东北，由拜台、祭台和坛碑组成。通高1.3米、碑高0.98米、宽0.33米、厚0.11米，碑座上宽0.43米、上厚0.18米、下宽0.53米、下厚0.36米，框边阴刻装饰，竖行阴刻碑文："通天大圣",碑底刻七瓣莲花纹装饰。'
    },
    {
        key: '11',
        name: '上安通天大圣祭坛',
        desc: '（建西镇安下村）',
        img: '/image/pic/pic7.png',
        voice: 'https://file.scxbwg.cn/audio/%E4%B8%8A%E5%AE%89%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%BB%BA%E8%A5%BF%E9%95%87%E5%AE%89%E4%B8%8B%E6%9D%91/@13132799.125,3083488.76,11.98z?querytype=s&da_src=shareurl&wd=%E5%BB%BA%E8%A5%BF%E9%95%87%E5%AE%89%E4%B8%8B%E6%9D%91&c=133&src=0&pn=0&sug=0&l=19&b=(13095054.025,3066306.52;13095909.025,3066740.52)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2',
        text: '位于建西镇安下村，明代建筑，坐东南向西北，占地面积约100平方米。由拜台、祭台和四通坛碑组成。其中，并立三通为一组，左碑竖行阴刻"黄公道者",碑右侧阴刻"喜舍信士朱尚口",通高1.1米、碑高0.7米、宽0.33米、厚0.1米，四坡顶碑帽，高0.13米、宽0.39米、厚0.29米；中碑竖行阴刻"通天大圣",落款"万历四年(1577年)七月吉旦立",碑右侧阴刻"喜舍信士朱文谦",通高1.3米、碑高0.9米、宽0.33米、厚0.1米，四坡顶碑帽，高0.16米、宽0.35米、厚0.30米；右碑竖行阴刻"本坛土地",碑右侧阴刻"喜舍信士朱□□",通高1.1米、碑高0.7米、宽0.33米、厚约0.1米，四坡顶碑帽，高0.13米、宽0.36米、厚0.31米。左前方约4米处立一"通天大圣王"坛碑，竖行阴刻碑文，通高1.3米、高0.93米、宽0.35米、厚0.1米，单檐歇山顶碑帽，高0.2米、宽0.45米、厚0.29米。'
    },
    {
        key: '12',
        name: '大山头通天大圣祭坛',
        desc: '（大历镇立墩村）',
        img: '/image/pic/pic9.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%A4%A7%E5%B1%B1%E5%A4%B4%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: '',
        text: '位于大历镇立墩村，明代建筑。坐西南向东北，占地面积约84平方米。中碑竖行阴刻"通天大圣",阴刻框边装饰，碑文下方刻莲瓣纹装饰，通高1.35米，碑高0.88米，宽0.33米，厚0.12米，碑侧阴刻"正德十三年(1518)七月信士官清和喜捨神牌";左碑竖行阴刻"黄公道者",通高1.1米，碑高0.7米，宽0.3米，厚0.12米；右碑竖行阴刻"本坛土地",题款"丁亥年七月吉日捨",落款"信女谢仙娘伏愿子孙绵远者",通高1.1米，碑高0.7米，宽0.3米，厚0.12米。坛碑间距约0.6米。'
    },
    {
        key: '13',
        name: '榜山通天大圣祭坛',
        desc: '（郑坊镇榜山村）',
        img: '/image/pic/pic10.png',
        voice: 'https://file.scxbwg.cn/audio/%E6%A6%9C%E5%B1%B1%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: '',
        text: '位于郑坊镇榜山村，明代建筑，坐东朝西，由拜台、祭台、香炉及前后两组坛碑组成，占地面积约60平方米。\n前组由四个香炉和三块坛碑组成，左碑高0.93米、宽0.37米、厚0.10米，碑文竖行阴刻"黄公道者";中碑高1.37米、宽0.51米、厚0.13米，碑文竖行阴刻"通天大圣仁济真君",题款"大明隆庆四年庚午冬月吉旦",落款"长寿官山劝缘福首卢大詹鼎立",背面阴刻"官山开坛架立桥庵主缘卢大詹鼎立",题款"官山寓居源头堡信官卢良琨助银二两",落款"官山信女余十良、卢兰良、黄钟良…";右碑高0.96米、宽0.37米、厚0.10米，碑文阴刻"本坛土地"。后组由三块坛碑组成，左碑高0.77米、宽0.34米、厚0.17米，碑文竖行阴刻"黄公道者";中碑高0.83米、宽0.51米、厚0.12米，碑文竖行阴刻"通天大圣仁济真君",落款"大明隆庆三年已巳岁立";右碑高0.77米、宽0.34米、厚0.17米，碑文竖行阴刻"本坛土地"。'
    },
    {
        key: '14',
        name: '范地通天大圣祭坛',
        desc: '（大历镇立墩村）',
        img: '/image/pic/pic12.png',
        voice: 'https://file.scxbwg.cn/audio/%E8%8C%83%E5%9C%B0%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E7%AB%8B%E5%A2%A9%E6%9D%91%E6%9D%91%E6%B0%91%E5%A7%94%E5%91%98%E4%BC%9A/@13141072.5775927,3090071.04932235,19z?querytype=s&da_src=shareurl&wd=%E7%AB%8B%E5%A2%A9%E6%9D%91%E6%9D%91%E6%B0%91%E5%A7%94%E5%91%98%E4%BC%9A&c=133&src=0&wd2=%E5%8D%97%E5%B9%B3%E5%B8%82%E9%A1%BA%E6%98%8C%E5%8E%BF&pn=0&sug=1&l=19&b=(13110369,3092328.57;13110848,3092787.57)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=7a508eb5354a487658f6be8f&device_ratio=1',
        text: '位于大历镇立墩村，明代建筑。坐西向东。由拜台、祭台和六通坛碑组成。祭坛占地面积约为126平方米。前后相隔一米设两组各三通坛碑，前组三碑石质，中碑竖行框边阴刻"通天大圣"落款"喜捨……张文……同室……",通高1.1米、碑高0.9米、宽0.34米、厚0.18米；左碑竖行框边阴刻"黄公道者",通高0.95米、高0.8米、厚0.15米，碑左侧阴刻"张……等";右碑竖行框边阴刻"本坛土地",通高0.95米、高0.8米、厚0.15米，碑右侧阴刻张文起、张景春等字。三碑间距0.7米。后排三碑为砖质，中碑竖行阴刻"通天大圣",题款"天顺二年(1458)……",右碑竖行阴刻"本坛士地";左碑仅残存"道者"两字，残碑高0.6米、宽0.26米、厚0.08米，坛后为不规则毛石围筑挡墙。'
    },
    {
        key: '15',
        name: '南亨通天大圣祭坛',
        desc: '（高阳乡南亨村）',
        img: '/image/pic/pic14.png',
        voice: 'https://file.scxbwg.cn/audio/%E5%8D%97%E4%BA%A8%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: '',
        text: '位于高阳乡南亨村，明代建筑，坐南朝北，由拜台、祭台、坛碑组成，祭坛平面呈风字形，占地面积约25平方米。片石垒砌拜台和祭台，长条方柱形坛碑高2米、宽厚均为0.28米，其中，碑帽宽0.4米，竖行阴刻碑文"通天大圣仁济真君"。前有小坛碑一通，高0.43米、宽0.2米、厚0.15米，阴刻楷书"玉封仁济真君通天大圣"。'
    },
    {
        key: '16',
        name: '郑坊通天大圣祭坛',
        desc: '（郑坊镇郑坊村）',
        img: '/image/pic/pic15.png',
        voice: 'https://file.scxbwg.cn/audio/%E9%83%91%E5%9D%8A%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E9%83%91%E5%9D%8A%E6%9D%91/@13104782.02,3067421.78,19z?uid=7c9e2acce0ae2a3c9ee32183&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '位于郑坊镇郑坊村，明代建筑。坐西向东，面阔9米，进深12米，占地面积约108平方米。由拜台、祭台和两块坛碑组成(左碑石质，右碑砖质),左碑阴刻"通天大圣",高0.7米、宽0.26米、厚0.07米，落款"明嘉靖…..";右碑阴刻"通天教主齐天大圣",高0.45米、宽0.29米、厚0.07米。'
    },
    // {
    //     name: '金银山通天大圣祭坛',
    //     desc: '（双溪街溪兰村）',
    //     img: '/image/pic/pic16.png',
    //     voice: '',
    //     mapUrl: '',
    //     text: '位于双溪街溪兰村，清道光二十年（1840）建。坐西向东，占地面积约30平方米，由拜台、祭台和坛碑组成。碑高1.38米、宽0.53米、厚0.1米，碑文竖行阴刻"通天大圣香位"，碑文右侧落款：清朝道光贰拾年正月口日吉旦。'
    // },
    {
        key: '17',
        name: '云路通天大圣祭坛',
        desc: '（郑坊镇峰岭村）',
        img: '/image/pic/pic18.png',
        voice: 'https://file.scxbwg.cn/audio/%E4%BA%91%E8%B7%AF%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/poi/%E5%B3%B0%E5%B2%AD%E6%9D%91/@13103926.9,3070174.48,19z?uid=dfc496b6934eecaf8936eefc&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl',
        text: '位于郑坊镇峰岭村，明代建筑。坐北向南，祭坛面阔25米，进深20米，占地面积约500平方米。依次由拜台、祭台、香炉及坛碑组成。碑高1.55米、宽0.47米、厚0.13米，碑文竖行阴刻"通天大圣仁济真君神位座"。'
    },
    {
        key: '18',
        name: '院尾齐天大圣祭坛',
        desc: '（郑坊镇罗坊村）',
        img: '/image/pic/pic19.png',
        voice: 'https://file.scxbwg.cn/audio/%E9%99%A2%E5%B0%BE%E9%BD%90%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E9%83%91%E5%9D%8A%E9%95%87%E7%BD%97%E5%9D%8A%E6%9D%91/@13103581.325,3064767.92,19z?querytype=s&da_src=shareurl&wd=%E9%83%91%E5%9D%8A%E9%95%87%E7%BD%97%E5%9D%8A%E6%9D%91&c=133&src=0&pn=0&sug=0&l=11&b=(13069381.538663967,3054774.931861264;13180562.570738686,3111210.6838149806)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2',
        text: '位于郑坊镇罗坊村，清同治九年(1870)建。坐北向南，占地面积约50平方米。由拜台、祭台、坛碑组成。碑高0.6米、宽0.33米、厚0.1米，碑文阴刻"济(齐)天大圣仁济真君",题款"同治九年",落款"吉立"。'
    },
    {
        key: '19',
        name: '殷坑通天大圣祭坛',
        desc: '（建西镇安下村）',
        img: '/image/pic/pic20.png',
        voice: 'https://file.scxbwg.cn/audio/%E6%AE%B7%E5%9D%91%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%AE%89%E4%B8%8B%E6%9D%91/@13132724.5,3083488.76,19z?querytype=s&da_src=shareurl&wd=%E5%AE%89%E4%B8%8B%E6%9D%91&c=133&src=0&wd2=%E5%8D%97%E5%B9%B3%E5%B8%82%E9%A1%BA%E6%98%8C%E5%8E%BF&pn=0&sug=1&l=19&b=(13130887.04,3091263.59;13131366.04,3091722.59)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=fd13a3f26c0b1cfab1077dff&device_ratio=1',
        text: '位于建西镇安下村，明代建筑，坐西北向东南，由拜台、祭台和三块坛碑组成，占地面积约30平方米。左碑竖行阳刻"黄公道者",通高1.22米、碑高0.93米、宽0.33米、厚约0.09米、碑座高0.29米，距中碑约0.36米；中碑竖行阳刻"通天大圣",通高1.33米、碑高1.03米、宽0.35米、厚约0.10米，碑座正面呈梯形，高0.3米、上底宽0.46米、下底宽0.5米、厚0.25米；右碑竖行阳刻"本坛土地",通高1.21米、碑高0.93米、宽0.33米、厚0.1米、碑座高0.28米，距中碑0.4米。'
    },
    {
        key: '20',
        name: '洋门通天大圣祭坛',
        desc: '（大干镇武坊村）',
        img: '/image/pic/pic21.png',
        voice: 'https://file.scxbwg.cn/audio/%E6%B4%8B%E9%97%A8%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%A4%A7%E5%B9%B2%E9%95%87%E6%AD%A6%E5%9D%8A%E6%9D%91/@13093218.2,3093541.28,19z?querytype=s&da_src=shareurl&wd=%E5%A4%A7%E5%B9%B2%E9%95%87%E6%AD%A6%E5%9D%8A%E6%9D%91&c=133&src=0&pn=0&sug=0&l=19&b=(13140833.0775927,3089841.54932235;13141312.0775927,3090300.54932235)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1',
        text: '位于大干镇武坊村，明代建筑。坐西北向东南。正对宝山南天门双圣享堂。占地面积约140平方米。前亭已毁，由拜台、祭合和三块坛碑组成，碑与碑座、碑帽连体，碑额雕饰荷叶帽。左碑竖行阴刻"黄公道者",通高0.76米、高0.63米、宽0.31米、厚0.10米，碑左侧阴刻"饶琦舍";中碑竖行阴刻"通天大圣",通高0.86米、高0.75米、宽0.32米、厚0.10米，框边剔地装饰，碑右侧阴刻"饶荣长舍";右碑竖行阴刻"本坛土地",通高0.76米、高0.63米、宽0.32米、厚0.10米，右侧阴刻"张政成舍"。'
    },
    {
        key: '21',
        name: '谢坊头通天大圣祭坛',
        desc: '（建西镇南山村）',
        img: '/image/pic/pic22.png',
        voice: 'https://file.scxbwg.cn/audio/%E8%B0%A2%E5%9D%8A%E5%A4%B4%E9%80%9A%E5%A4%A9%E5%A4%A7%E5%9C%A3%E7%A5%AD%E5%9D%9B.mp3',
        mapUrl: 'https://map.baidu.com/search/%E5%8D%97%E5%B1%B1%E6%9D%91/@13131126.54,3091493.09,19z?querytype=s&da_src=shareurl&wd=%E5%8D%97%E5%B1%B1%E6%9D%91&c=133&src=0&wd2=%E5%8D%97%E5%B9%B3%E5%B8%82%E9%A1%BA%E6%98%8C%E5%8E%BF&pn=0&sug=1&l=11&b=(13077800.885,3059474.285;13200424.885,3176978.285)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=6ee01020bcec97ef52e5c5fd&device_ratio=1',
        text: '位于建西镇南山村，明代建筑。坐东南向西北。由拜台、祭台、香炉及三块坛碑组成，占地面积约30平方米。左碑阴刻"黄公道者",通高1.03米、高0.76米、宽0.25米、厚0.10米；中碑阴刻"通天大圣",通高1.09米、高0.83米、宽0.28米、厚0.10米：右碑阴刻"本坛土地",通高1.0米、高0.76米、宽0.25米、厚0.08米，阴刻框边装饰。地面散落残碑两块，一块碑文"通天大圣",另一块"黄公道者"残碑，仅见黄公两字。'
    }
]);
const dialog = ref(false);
const itemDetail = ref({});
const hoverKey = ref(null);
const hoverName = ref(null);
let audio;
let audioName = '';
let isPlaying = ref(false);
function mouseenter (item) {
    hoverKey.value = item.key;
    hoverName.value = item.name;
}
function handleItem (val) {
    itemDetail.value = val;
    dialog.value = true;
    console.log(val);
}

function stopVoice () {
    if (audio) {
        audio.pause();
        audio.currentTime = 0;
        isPlaying.value = false;
    }
}
function playVoice () {
    isPlaying.value = true;
    // 播放语音
    audio = new Audio(itemDetail.value.voice);
    audio.play();
    isPlaying.value = true;
}

function handleTipClick () {
    window.open(itemDetail.value.mapUrl, '_blank');
}

onUnmounted(() => {
    const audio = new Audio(itemDetail.value.voice);
    audio.pause();
    audio.currentTime = 0;
});
</script>
<style lang="scss" scoped>
.map {
    padding-left: 166px;
    //    background:#ececec;
    display: flex;
}
.map-box {
    width: 901.12px;
    height: 839px;
    background: url("~@/assets/imgs/whdh/3@2x.png") no-repeat;
    background-size: contain;
    position: relative;
    .map-tag {
        text-align: center;
        position: absolute;
        transition: all 0.3s;
        cursor: pointer;
        span {
            padding: 10px;
            background: #a26e3f;
            border-radius: 9px;
            font-weight: 700;
            color: #ffffff;
            font-size: 13px;
            text-align: center;
            margin: auto;
        }
        i {
            width: 0px;
            height: 108px;
            border: 2px solid;
            border-color: #d4776c;
            display: block;
            margin: auto;
        }
        &.key1 {
            top: 310px;
            left: 170px;
        }
        &.key2 {
            top: 450px;
            left: 190px;
        }
        &.key3 {
            top: 190px;
            left: 580px;
        }
        &.key4 {
            top: 280px;
            left: 250px;
        }
        &.key5 {
            top: 130px;
            left: 540px;
        }
        &.key6 {
            top: 280px;
            left: 610px;
        }
        &.key7 {
            top: 510px;
            left: 230px;
        }
        &.key8 {
            top: 220px;
            left: 590px;
        }
        &.key9 {
            top: 470px;
            left: 350px;
        }
        &.key10 {
            top: 530px;
            left: 100px;
        }
        &.key11 {
            top: 390px;
            left: 480px;
        }
        &.key12 {
            top: 300px;
            left: 560px;
        }
        &.key13 {
            top: 540px;
            left: 240px;
        }
        &.key14 {
            top: 300px;
            left: 570px;
        }
        &.key15 {
            top: 320px;
            left: 740px;
        }
        &.key16 {
            top: 520px;
            left: 180px;
        }
        &.key17 {
            top: 500px;
            left: 190px;
        }
        &.key18 {
            top: 580px;
            left: 190px;
        }
        &.key19 {
            top: 380px;
            left: 490px;
        }
        &.key20 {
            top: 280px;
            left: 90px;
        }
        &.key21 {
            top: 290px;
            left: 470px;
        }
    }
}
.map-text {
    width: 538px;
    height: 486px;
    background: #885d36;
    padding: 24px 18px;
    box-sizing: border-box;
    margin-top: 122px;
    margin-left: 55px;
    overflow: hidden;
    h4 {
        text-align: center;
        margin-bottom: 35px;
        font-weight: 700;
        color: #ffffff;
        font-size: 24px;
        text-align: center;
    }
    ul {
        display: grid;
        grid-template-columns: 165px 165px 165px;
        gap: 6px;
        li {
            font-weight: 700;
            color: #ffffff;
            font-size: 16px;
            text-align: center;
            height: 82px;
            background: #a26e3f;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            cursor: pointer;
            &.active {
                background: #654425 !important;
            }
            &:hover {
                background: #654425 !important;
            }
            .desc {
                color: rgba(#ffffff, 0.5);
                font-size: 12px;
                text-align: center;
            }
        }
    }
    :deep(.el-carousel__button) {
        background: #ffffff;
        border-radius: 50%;
        width: 10px;
        height: 10px;
    }
}
.ex-tip-wrapper {
    background: url('~@/assets/imgs/bof@3x.png');
    background-size: cover;
}
.ex-tips-tit {
    height: 330px;

    width: 100%;
    position: relative;
    .ex-l-icon {
        opacity: 70%;
        width: 26px;
        height: 24.86px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .ex-r-icon {
        opacity: 70%;
        width: 26px;
        height: 24.86px;
        position: absolute;
        top: 0;
        right: 0;
    }
    .ex-voice-icon {
        width: 76px;
        height: 76px;
        position: absolute;
        top: 300px;
        right: 17px;
        cursor: pointer;
    }
}
.ex-tips-tit-con {
    padding-top: 53px;

    .ex-img-desc {
        width: 217px;
        height: 163px;
        display: block;
        margin: 0 auto;
    }
    .ex-h5 {
        font-weight: 700;
        color: #ffffff;
        font-size: 24px;
        text-align: center;
        margin-top: 23px;
        .ex-img {
            vertical-align: middle;
            width: 17.05px;
            height: 27px;
        }
    }
    .ex-desc {
        font-weight: 700;
        color: #ffffff;
        opacity: 0.5;
        font-size: 12px;
        margin-top: 6px;
        text-align: center;
    }
}
.ex-tip-content {
    padding: 50px 50px 20px;
    color: #535353;
    font-size: 13px;
     background: #efefef;
     text-indent: 2em;
}
.ex-tip-btn {
    width: 229.9px;
    height: 56px;
    display: block;
    margin: 8px auto;
    margin-top: 50px;
}
.ex-close {
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    position: absolute;
    bottom: -50px;
    left: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
}
::v-deep .el-dialog__body {
    padding: 0 !important;
    width: 100%;
}
::v-deep .el-dialog{
    background:transparent;
}
</style>
